import {
  createColDef,
  ItemGridFilterScreenType,
  SCREEN_TYPE_TO_DISPLAY,
} from "@package/ui-apollo-components";
import {
  CreateProfileDocument,
  DeleteProfileDocument,
  GetProfileDocument,
  GetProfileGridDocument,
  GetProfileListNameIdDocument,
  useGetProfileGridQuery,
  type ProfileModel,
  type ScreenType,
} from "@package/ui-gql/index-data-access";
import type { ColDef, ValueFormatterParams } from "ag-grid-community";
import { useMemo } from "react";
import { SidebarEntryPath } from "../../../../constants/contants";
import { useAppSelector } from "../../../../store/store";
import { ItemGridWithToolbar } from "../../../ItemGrid/ItemGridWithToolbar";
import { WallPreviewProfile } from "../../../WallPreview/WallPreviewProfile";

export function ProfileGrid() {
  const variables = useAppSelector(
    (state) => state.itemGrid.profiles.variables,
  );
  const selectedItemId = useAppSelector(
    (state) => state.itemGrid.profiles.selectedItemId,
  );

  const {
    data: dataProfiles,
    loading: loadingProfiles,
    error: errorProfiles,
  } = useGetProfileGridQuery({ variables });

  const columnDefs = useMemo<ColDef[]>(
    () => [
      createColDef<ProfileModel>("name", "Name", 1, 200),
      {
        ...createColDef<ProfileModel>("type", "Screen Type", 1, 200),
        sortable: false,
        valueFormatter: (params: ValueFormatterParams<ProfileModel>) => {
          const type = params.value as ScreenType;
          if (type) {
            return SCREEN_TYPE_TO_DISPLAY[type];
          }

          return "";
        },
      },
      createColDef<ProfileModel>("updatedAt", "Last Updated", 1, 125),
    ],
    [],
  );

  return (
    <div className="flex flex-col w-full h-full">
      <div className="shrink">
        <ItemGridWithToolbar
          propsItemGrid={{
            sidebarEntryPath: SidebarEntryPath.profiles,
            columnDefs,
            data: dataProfiles,
            error: !!errorProfiles,
            loading: !dataProfiles && loadingProfiles,
            filtersSupported: true,
            filterPanels: [<ItemGridFilterScreenType key="screenType" />],
          }}
          propsItemGridToolbar={{
            title: "Canvas",
            sidebarEntryPath: SidebarEntryPath.profiles,
            createEnabled: true,
            deleteDocument: DeleteProfileDocument,
            deleteEnabled: true,
            deleteRefetchQueries: [
              GetProfileDocument,
              GetProfileGridDocument,
              GetProfileListNameIdDocument,
            ],
            duplicateCreateDocument: CreateProfileDocument,
            duplicateEnabled: true,
            duplicateGetDocument: GetProfileDocument,
            duplicateNameField: "name",
            duplicateRefetchQueries: [
              GetProfileGridDocument,
              GetProfileListNameIdDocument,
            ],
            editEnabled: true,
            exportEnabled: false,
          }}
        />
      </div>
      <div className="flex-0 mt-4">
        <hr />
      </div>
      <div
        className={`flex-0 mt-4 z-20 ${selectedItemId ? "sticky bottom-4" : ""}`}
      >
        <WallPreviewProfile profile={selectedItemId} />
      </div>
    </div>
  );
}
